<template>
  <div class="lengend" :class="pz" v-if="btmList.length > 0">
    <div class="flex-around topNav">
      <div class="box">
        <div class="flex warn-table" v-if="btmList.length > 0">
          <div class="table flex" v-for="(it, index) in btmList" :key="index">
            <img :src="it.pic" class="img" v-if="it.pic" />
            <span
              class="point-zzdh-y"
              v-if="it.name === '种植大户' && !it.pic"
            ></span>
            <span style="margin-left: 5px">{{ it.name }}</span>
          </div>
        </div>
        <!-- <div
          v-if="btmList.length == 0"
          class="flex warn-tables"
          style="color:#fff;font-size:0.09rem;"
        >
          Loading...
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    btmList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    pz: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      //   btmList: [
      //     {
      //       name: "面积>40万亩",
      //       pic: require("images/map/red.jpg")
      //     },
      //     {
      //       name: "面积>1万亩",
      //       pic: require("images/map/fs.jpg")
      //     },
      //     {
      //       name: "面积>1000亩",
      //       pic: require("images/map/dfs.jpg")
      //     }
      //   ],
    };
  }
};
</script>
<style lang="stylus" scoped>
.lengend.left-top
  bottom unset
  left unset
  top 1rem
  right 26.5%
.lengend.left-zl
  left 5px
.lengend
  position absolute
  color #fff
  z-index 10
  bottom 5px
  left 26.5%
  width 8.8%
  padding 5px
  border 1px solid #00A9C7
  background-color rgba(1,29,46, 0.8)
  box-shadow inset 0 0 0.05208rem #00b1cf
  border-radius 5px
  font-size 0.08rem
  transition .3s
  >>>.el-checkbox__inner
    border-color #1EC4F8
  >>>.el-checkbox__input.is-checked
    border-color #1EC4F8
.mainList
  flex-wrap wrap
  width 100%
  height 100%
.lengCube
  width 50%
  height 23%
.lengCube:last-child
  padding-bottom 0
.imggs
  width 36px
  display flex
  justify-content center
  margin-right 5px
@media (min-height 1400px)
  .lengend
    font-size 0.06rem
    padding 5px 20px
.topNav
  z-index 9
  color #ccc
  display flex
  flex-direction column
  width 100%
  height 100%
  display flex


.active
  color #fff
  background-color #0D719F
.box
  width 100%
.warn-table
  padding 5px 0 5px 7px
  height calc(100% - 10px)
  overflow-y auto
  flex-wrap wrap
  &::-webkit-scrollbar
    width 4px
    background-color #19295a
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color $textColor
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
.table
  width 100%
  font-size 12px
  padding 2px 0
.icon
  width 17px
  height 17px
.warn-tables
  display flex
  justify-content center
  align-items center
  width 100%
.img
  width 17px
  height 17px
  vertical-align middle
  object-fit contain
.imgUrl
  width 33px
.point-zzdh-y
  width 10px
  height 10px
  border-radius 50%
  background #f3d013
@media (max-width 1280px)
  .imgUrl
    width 15px
  .imggs
    margin-right 0px
</style>
